import React, { useState, useEffect } from "react";
import axios from "axios";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { toast } from "react-toastify";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { audioDefaultURL } from "../../../components/CommonApis/CommonAudioApis";
import { donwloadCSV, downloadPDF, downloadXLSX, findUploadName } from "../../../components/CommonMethod/CommonMethods";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IconDeleteFigma, IconDeleteSolid, IconEditFigma, IconMyDelete, IconSolidEdit } from "../../../Assets/MyIcons";
import { Link } from "react-router-dom";
import { FaEllipsisVertical } from "react-icons/fa6";
import { CiShare1 } from "react-icons/ci";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { LiaUndoAltSolid } from "react-icons/lia";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { BiRecycle } from "react-icons/bi";
import { RxReload } from "react-icons/rx";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { connect } from "react-redux";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import useTablePage from "../../../components/CommonComponents/useTablePage";


function AudioList({ siteTheme }) {
  const headers = getItemToken('access_token')
  const BaseUrl = process.env.REACT_APP_Baseurl
  const listApi = `${BaseUrl}/admin/audio/index`
  const multiDelete = `${BaseUrl}/admin/audio/multi-delete`
  const languageApi = `${BaseUrl}/admin/User-Translate-Language`
  const { fetchRequest, deleteImageFile } = useMyContext()
  const { page, limit, handlePageChange, handleSizePerPageChange } = useTablePage(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [type, setType] = useState(null)
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState('')
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [languageCode, setLanguageCode] = useState('');


  const [formData, setFormData] = useState({
    state: "formData",
    view_type: "list",
    view_type_option: [{
      name: "List",
      value: "list"
    },
    {
      name: "Gallery",
      value: "grid"
    }]
  })

  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const fetchData = async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: { type, page, 
        limit: formData?.title ? total?.count_all : limit, 
        title: formData?.title, 
        draft 
      },
      data: {},
    })
      .then(response => {
        const result = response;
        const updatedList = result?.data?.map((item) => {
          const UploadStatus = findUploadName(item?.uploaded_by);
          return {
            ...item, uploaded_by: UploadStatus,
          };
        });
        setApiData(updatedList);
        setTotal(result?.pagination)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
      })
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: { title: find == "ALL" ? null : formData?.title, type: null, page, limit: find == "ALL" ? total?.count_all : total?.totalItems },
      data: {},
    })
    const updatedList = data?.data?.map((item) => {
      const UploadStatus = findUploadName(item?.uploaded_by);
      return {
        ...item, uploaded_by: UploadStatus,
        source_type: item?.source_type == 1 ? "Video" : "Audio"
      };
    });
    if (type == "CSV") {
      await donwloadCSV(updatedList, "AUDIO-LIST")
    }
    if (type == "PDF") {
      await downloadPDF(updatedList, "AUDIO-LIST", ["INDEX", "ID", "TITLE", "DURATION", "SOURCE TYPE", "MP3 URL", "MP4 URL", "M3U8 URL"])
    }
    if (type == "XLSX") {
      await downloadXLSX(updatedList, "AUDIO-LIST", ["INDEX", "ID", "TITLE", "DURATION", "SOURCE TYPE", "MP3 URL", "MP4 URL", "M3U8 URL"])
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "Audio");
  }

  const handleConfirmDelete = async (actionType) => {
    setShowOverlay(true);
    await handleDeleteImage();
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDelete}`,
      params: {},
      data: { id: itemToDelete, action: actionType || deleteActionType },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([])
          setShowOverlay(false)
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message)
        setShowOverlay(false)
      })
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([])
    setDeleteActionType(2)
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    if (draft === 1) {
      setDeleteActionType(3)
    }
  };
  const singlePeramanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setDeleteActionType(1)
  }
  const handleDeletedata = (actionType) => {
    handleConfirmDelete(actionType);
    closeModal();
  };


  const columns = [
    {
      dataField: "title",
      text: "Audios",
      width: "30%",
      formatter: (cell, row) => {
        const imageSrc = row?.image_url || row?.Thumbnail || row?.image || row?.album;
        const hasImage = !!imageSrc;
        const firstLetter = row?.title?.slice(0, 1)?.toUpperCase();
        const displayTitle = row?.title || row?.albumname || row?.artist_name || "Untitled";
        const trimmedTitle = `${displayTitle.slice(0, 15)}...`;
        const trackSlug = row?.slug || row?.artist_slug;
        const url = siteTheme?.translate_checkout === 1
          ? `${process.env.REACT_APP_Baseurl_Frontend}/${languageCode}/music/track/${trackSlug}`
          : `${process.env.REACT_APP_Baseurl_Frontend}/music/track/${trackSlug}`;
        return (
          <div className="d-flex justify-content-between align-items-center">
            {hasImage ? (
              <img key={imageSrc} src={imageSrc} alt={displayTitle} className="profile theme-bg-color-secondary" />
            ) : (<div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
              {firstLetter}
            </div>)}
            <div className="rightVideoTitle">
              <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank" to={url} >
                <span>{trimmedTitle}</span>
                <CiShare1
                  style={{ width: "15px", height: "15px", strokeWidth: "1px", marginLeft: "6px", }} />
              </Link>
              {row?.duration !== "0" && (<span className="me-1 dateText theme-text-color table-subheading"> {row.duration}</span>)}
              <span className="dateText table-subheading theme-text-color">  {row.upload_on} </span>
            </div>
          </div>
        );
      },
      sort: true,
    },
    {
      dataField: "uploaded_by",
      text: "Upload by",
    },
    {
      dataField: "current_status",
      text: "Status",
      formatter: (cell, row) => {
        const isDisapproved = cell === 2 || row?.active === 2 || row?.status === 2;
        const isPublished = cell === 1 || cell === "PUBLISHED";
        const isScheduled = cell === "SCHEDULED";
        const isUnpublished = cell === "UNPUBLISHED";
        
        const statusText = isDisapproved ? "DISAPPROVED" : cell;
        const statusClass = isPublished ? "PUBLISHED_active" : isScheduled ? "DISABLED_active" : "UNPUBLISHED_active";
        
        return <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${statusClass}`} > {statusText} </div>
      }
    },
    {
      dataField: "banner",
      text: "Slider",
      formatter: (cell, row) =>
        <AdminSwitch name="banner" checked={cell == 1} onChange={() => handleToggle(row)} id={row?.id} />
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => {
        return <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className="editdropdown-menu theme-bg-color rounded-3 overflow-hidden">
            {draft !== 1 && (<Link to={`${"/edit-audio/"}${row?.id}`} className="theme-text-color  theme-bg-color">
              <span className="theme-text-color">
                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Edit Meta" classname='ms-2 theme-text-color'></MessageBox>
              </span>
            </Link>)}
            {draft !== 1 && <Link to={`/edit-new-audio/${row?.id}`} className="theme-text-color  theme-bg-color">
              <IconEditFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text={`Edit Audio`} classname='ms-2 theme-text-color'></MessageBox>
            </Link>}
            <div onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
              <MessageBox text={`${draft == 1 ? "undo" : "Delete"}`} classname='ms-2 theme-text-color'></MessageBox>
            </div>
            {draft == 1 && (<div onClick={() => singlePeramanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color'></MessageBox>
            </div>)}
          </div>
        </div >
      }
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
  };

  const selectRow = {
    selected: itemToDelete,
  };
  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };
  const handleInput = (e) => {
    const { type, name, value, checked } = e.target
    if (type === "search") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }))
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  }
  const reloadAction = () => {
    setDraft(0)
    setWithoutRefresh(prev => !prev)
  }
  const reCycleBin = () => {
    setDraft(prev => prev === 1 ? 0 : 1);
    setItemToDelete([]);
  };


  const confirmToggle = async () => {
    setShowOverlay(true);
    setShowModal(false);
    try {
      const newStatus = currentItem?.banner === 1 ? 0 : 1;

      const response = await axios.post(`${audioDefaultURL?.sliderApi}`, {
        audio_id: currentItem?.id,
        banner_status: newStatus
      },
        { headers: await getItemToken("access_token") });


      const result = response.data
      if (result.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setCurrentItem(null);
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };


  const handleToggle = async (item) => {
    setCurrentItem(item);
    setShowModal(true);
  };

  useEffect(() => {
    if (draft === 0) {
      setDeleteActionType(2)
    }
    if (draft === 1) {
      setDeleteActionType(3)
    }
    if (draft === 1) {
      setDeleteActionType(1)
    }
  }, [draft])


  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);



  return (
    <div className="">
      {showOverlay && <Response_Processing />}
      {showModal && <AdminSliderModal modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.banner} />}
      {modelClose && <AdminDeleteModal messageClassName={deleteActionType === 1 ? "warningColor" : ""} headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"} message={deleteActionType == 2 ? "Are you sure you want to delete" : deleteActionType == 3 ? "Are you sure you want to Undo item" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to Delete"} modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={"custom"} actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 2 ? "Delete" : deleteActionType == 3 ? "Undo" : ""} />}
      <AdminNavbar heading={"All Audios"} totalDataLength={total?.totalItems} deleteCount={0} navigation={"/add-audio"} deleteMethod={openModal} navText={"Upload Audio"} />
      <div className='theme-bg-color p-3 rounded-3 mb-5'>
        <div className='d-flex align-items-center flex-wrap justify-content-between  mb-3'>
          <input type='search' placeholder='Search' name="title" className='rounded-3 col-3 theme-border-color border-solid-width border-solid table-search  theme-bg-color-secondary' onChange={handleInput} />
          <div className='d-flex align-items-center justify-content-end'>
            {(draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg"} saveMethod={() => { setModelClose(true); setDeleteActionType(2) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Undo" className={"mx-3 btn-success"} saveMethod={() => { setModelClose(true); setDeleteActionType(3) }} /> : ""}
            {(draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete Permanent" className={"me-3  warningColorBg"} saveMethod={() => { setModelClose(true); setDeleteActionType(1) }} /> : ""}
            <button className={` reloadButton p-2 me-2 custom-tool-tip-parent  border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin}>
              <BiRecycle style={{ width: "18px", height: "15px" }} />
              <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <button className={`bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
              <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
              <AdminTooltip  text="Refresh"  top={"-41px"} className="d-none custom-tool-tip" />

            </button>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX </li>
              </ul>
            </div>
            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"  >
                <span className="fw-bolder text-white">Export all</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="dropdownMenuButton1" >
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                <li className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX </li>
              </ul>
            </div>
          </div>
        </div>

        <AdminTable data={apiData}
          loading={loading}
          options={options}
          handlePageChange={handlePageChange}
          page={page}
          pagination={total}
          handleSizePerPageChange={handleSizePerPageChange}
          columns={columns}
          limit={limit}
          selectRow={selectRow}
          multiSelect
          onRowSelect={handleRowSelect}
          onSort={handleSort}
          onSelectAll={handleSelectAll}
          viewType={formData?.view_type}
        />
      </div >

    </div>
  );
}

const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(AudioList)